import {
  FormLabel as CustomLabel,
  FormControl,
  Spinner,
} from "react-bootstrap";
import { components } from "react-select";
import { AlertIcon } from "../../icons/otherIcons";
import { DropDownIcon } from "../../icons/inputIcons";
import { CrossIcon } from "../../icons/btnIcons";
import Btn from "../button/Btn";

const FormFeedback = ({ className = "", message = "" }) => {
  return (
    <FormControl.Feedback
      type="invalid"
      className={`d-inline-flex gap-1 ${className}`.trim()}
    >
      <i className={`ratio-1 flex-center `}>
        <AlertIcon size={12} />
      </i>
      <span className="fs-xs">{message}</span>
    </FormControl.Feedback>
  );
};
const FormLabel = ({
  className = "",
  id = "",
  labelName = "",
  required = false,
}) => {
  return (
    <CustomLabel className={className} htmlFor={id}>
      {labelName}
      {required && "*"}
    </CustomLabel>
  );
};
const DropIcon = (props) => {
  const { selectProps } = props || {};
  const isOpen = !!selectProps?.menuIsOpen;
  return (
    <DropDownIcon
      style={{
        transition: "transform 0.3s ease",
        transform: isOpen ? "rotate(-180deg)" : "none",
      }}
      className={isOpen ? "text-primary" : "text-secondary"}
    />
  );
};
const LoadingMessage = (props) => {
  return (
    <components.LoadingMessage {...props}>
      <div className="flex-center gap-2 py-2">
        <Spinner
          animation="border"
          size="sm"
          role="status"
          className="text-primary"
          style={{ width: "14px", height: "14px", borderWidth: "2px" }}
        />
        <span className="text-secondary fs-xs">Loading...</span>
      </div>
    </components.LoadingMessage>
  );
};

const NoOptionsMessage = (props) => {
  const { selectProps } = props;
  const noOptionsAction = selectProps?.noOptionsAction;
  const newOption = selectProps?.newOption;

  return (
    <components.NoOptionsMessage {...props}>
      <div className="flex-column gap-2 py-2">
        <span className="text-secondary fs-xs">No Options Found</span>
        {noOptionsAction && !newOption && (
          <Btn
            variant="link"
            size="sm"
            className="text-decoration-none"
            onClick={() => {
              if (noOptionsAction.onClick) {
                noOptionsAction.onClick();
                props.selectProps?.onMenuClose?.();
              }
            }}
            isAddBtn
            title={noOptionsAction.label || " Create New"}
          />
        )}
      </div>
    </components.NoOptionsMessage>
  );
};

const ClearIndicator = (props) => {
  return (
    <components.ClearIndicator {...props}>
      <CrossIcon
        size={14}
        className="text-danger"
      />
    </components.ClearIndicator>
  );
};

const MenuList = (props) => {
  const { children, selectProps } = props;
  const { newOption } = selectProps || {};

  return (
    <components.MenuList {...props}>
      {children}
      {newOption && (
        <div className="sticky-bottom bg-white border-top pt-3 px-1 mt-1 z-2">
          <Btn
            variant="link"
            size="sm"
            className="text-decoration-none w-100 text-start shadow-none p-0"
            onClick={() => {
              newOption.onClick?.();
              props.selectProps.onMenuClose?.();
            }}
            isAddBtn
            title={newOption.label || "Add New"}
          />
        </div>
      )}
    </components.MenuList>
  );
};

const MultiValueRemove = (props) => {
  return (
    <components.MultiValueRemove {...props}>
      <CrossIcon size={12} />
    </components.MultiValueRemove>
  );
};

export {
  FormFeedback,
  FormLabel,
  DropIcon,
  LoadingMessage,
  NoOptionsMessage,
  ClearIndicator,
  MenuList,
  MultiValueRemove,
};
